import React from 'react';
import classNames from 'classnames';
import stylesBreadcrumb from './breadcrumb.module.css.js';

function NodeBreadcrumb({ 'data-testid': dataTestId, node: { id, displayPrefix, prefix, title }, generalNodeLabel, }) {
    const getTitle = () => {
        if (id === 'general' && generalNodeLabel)
            return generalNodeLabel;
        return displayPrefix ? `${prefix} ${title}` : title;
    };
    return (React.createElement("span", { "data-testid": dataTestId, className: stylesBreadcrumb.breadcrumb },
        React.createElement("i", { className: classNames(stylesBreadcrumb.icon, 'bc-icon', 'bc-icon-bookmark'), role: 'img', "aria-label": 'icon-section' }),
        React.createElement("span", { className: stylesBreadcrumb.text }, getTitle())));
}

export { NodeBreadcrumb };
